<template>
    <div class="fb-share-button btn inline-submenu-btn with_icon btn-secondary"
        :data-href="'https://sportips.fr/race' + $route.fullPath" data-layout="" data-size="">
        <b-icon icon="facebook" aria-hidden="true"></b-icon>
        <a target="_blank"
            :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI('https://sportips.fr/race' + $route.fullPath) + '&amp;src=sdkpreparse'"
            class="fb-xfbml-parse-ignore">Partager</a>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped></style>